
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/category/[slug]",
      function () {
        return require("private-next-pages/community/category/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/category/[slug]"])
      });
    }
  